export const setPersistentValue = (key, value) => {
	localStorage.setItem(key, value);
};

export const getPersistentValue = (key) => {
	return localStorage.getItem(key);
};

export const removePersistentValue = (key) => {
	return localStorage.removeItem(key);
};

export const setSessionValue = (key, value) => {
	sessionStorage.setItem(key, value);
};

export const getSessionValue = (key) => {
	return sessionStorage.getItem(key);
};

export const removeSessionValue = (key) => {
	return sessionStorage.removeItem(key);
};

export const setCookieValue = (key, value, expirationInDays, acrossSubdomains) => {

	// console.log("setCookieValue", key, value, expirationInDays, acrossSubdomains);
	const maxExpireFor32bit = 2147483647; // for backward compatability with 32 bit machines, max expire is 2038-01-19 04:14:07

	let d = new Date();
	if (expirationInDays || expirationInDays === 0) {
		d.setTime(d.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
	}
	else {
		d.setTime(maxExpireFor32bit);
	}

	let location = window.location;

	let domain = null;
	if (location.hostname !== "localhost") {
		domain = location.hostname.split('.').reverse()[1] + "." + location.hostname.split('.').reverse()[0];
	}

	let cookie = key + "=" + value + ";" 
		+ "expires=" + d.toUTCString() + ";"
		+ (domain && acrossSubdomains ? "domain=" + domain + ";" : "")
		+ "path=/";

	// console.log("setCookieValue cookie", cookie);

	document.cookie = cookie;
};

export const getCookieValue = (key) => {
	let name = key + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

export const removeCookieValue = (key) => {
	document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};



// WEBPACK FOOTER //
// ./src/functions/persistent.js